import { reactive } from 'vue';

export const state = reactive({
  hasStoreChartData: false,
  graphSeries: {},
});
